export const batchExecutionDetailsModalReducerKey = 'batchExecutionDetailsModalReducerKey';
export const batchExecutionDetailsModalSetIsLoadingReducerType = 'batchExecutionDetailsModalSetIsLoadingReducerType';
export const batchExecutionDetailsModalSetQueriesReducerType = 'batchExecutionDetailsModalSetQueriesReducerType';
export const batchExecutionDetailsModalSetFilenameReducerType = 'batchExecutionDetailsModalSetFilenameReducerType';
export const batchExecutionDetailsModalSetContextReducerType = 'batchExecutionDetailsModalSetContextReducerType';
export const batchExecutionDetailsModalSetOptionsReducerType = 'batchExecutionDetailsModalSetOptionsReducerType';
export const batchExecutionDetailsModalSetDetailsListReducerType = 'batchExecutionDetailsModalSetDetailsListReducerType';
export const batchExecutionDetailsModalSetIsShowPicturesReducerType = 'batchExecutionDetailsModalSetIsShowPicturesReducerType';

export const typeOfBatchExecutionDetailsModal = 'typeOfBatchExecutionDetailsModal';

export const DICTIONARY = {
  searchBy: {
    exact: 'as drawn',
    similarity: 'similarity',
    substructure: 'substructure',
    sub_hetero: 'substructure on heteroatoms',
    group: 0,
  },
  similarity: {
    text: 'similarity',
    group: 0,
  },
  tautomers: {
    tautomers: 'tautomers',
    group: 1,
  },
  stereo: {
    stereo_absolute: 'only absolute stereo',
    group: 1,
  },
  extraRings: {
    no_extra_rings: 'additional ring closures allowed',
    group: 1,
  },
  markush: {
    markush: 'related markush',
    group: 1,
  },
  salts: {
    salts: 'salts',
    group: 1,
  },
  mixtures: {
    mixtures: 'mixtures',
    group: 1,
  },
  isotopes: {
    isotopes: 'isotopes',
    group: 1,
  },
  charges: {
    charges: 'charges',
    group: 1,
  },
  radicals: {
    radicals: 'radicals',
    group: 1,
  },
  ignoreAtomMapping: {
    ignore_mappings: 'atom mappings ignored',
    group: 1,
  },
  keepFragments: {
    merge_fragments: 'no separate fragments',
    separate_fragments: 'only separate fragments',
    group: 1,
  },
  atoms: {
    text: ' # of atoms',
    group: 2,
  },
  ringClosures: {
    text: ' # of rings',
    group: 2,
  },
  fragments: {
    text: ' # of fragments',
    group: 2,
  },
};
